exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* ---------- COLORS ----------*/\n.xs-dropdown-list {\n  width: 100%;\n}\n.xs-dropdown-list .xs-select {\n  outline: none;\n  display: flex;\n  height: 100%;\n  align-items: center;\n}\n.xs-placeholder-for-dropdownlist {\n  font-size: 20px !important;\n  margin-top: 12px !important;\n  color: #60606F !important;\n  height: 34px;\n  display: inline-flex;\n  position: initial;\n  font-size: 15px;\n  text-align: left;\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n}\n.xs-menu-item {\n  padding: 0 10px;\n  overflow: hidden;\n  padding-right: 15px;\n  width: 100%;\n  white-space: nowrap;\n}\n", ""]);

// exports
